import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import * as _ from 'google-libphonenumber';
import { Subject } from 'rxjs';

import { SlideInOutAnimation } from '@app/shared/animations/animations';
import { MobileValidator } from '@app/shared/directives/mobile.directive';
import { CountryInternational } from '@app/shared/models';
import { CountryIntlService } from '@app/shared/services';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OnlyTellNumberDirective } from '@app/shared/directives/only-tell-number.directive';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface State {
  flag: string;
  name: string;
  population: string;
}

@Component({
    selector: 'tc-select-country-phone-code',
    imports: [
        MatFormFieldModule,
        MatInputModule,
        CommonModule,
        TranslateModule,
        FormsModule,
        OnlyTellNumberDirective,
        MatTooltipModule
    ],
    templateUrl: './select-country-phone-code.component.html',
    styleUrls: ['./select-country-phone-code.component.scss'],
    animations: SlideInOutAnimation,
    encapsulation: ViewEncapsulation.None
})
export class SelectCountryPhoneCodeComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() phoneNumberEmit = new EventEmitter<string>();
  @Input() currentMobileNumber: string;

  unsubscribeAll$ = new Subject<void>();

  form: FormGroup;

  // data
  allCountries: CountryInternational[] = [];
  selectedCountry: CountryInternational;
  searchValue: string;
  phoneNumber: string;

  // boolean
  showOptions: boolean;
  isReadOnly: boolean;

  stateCtrl = new FormControl();
  filteredCountries: CountryInternational[];

  constructor(
    private countryIntlService: CountryIntlService,
    private fb: FormBuilder,
    private eRef: ElementRef) {
  }
  ngAfterViewInit(): void {
    //  document.getElementById('phoneNumberInput').focus();
  }

  /*******************************************************************
    Lifecycle Hook
   *******************************************************************/

  ngOnInit(): void {
    this.selectedCountry = new CountryInternational();
    this.initForm();
    this.fetchCountryData();
    this.filteredCountries = this.allCountries;
    this.showOptions = false;
    this.manageIfHasCurrentPhoneNumber();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }


  /*******************************************************************
    Fetch Data
   *******************************************************************/

  protected fetchCountryData(): void {
    if (this.allCountries.length > 0) { return; }
    this.allCountries = this.countryIntlService.getCountriesData(
      _.PhoneNumberType.MOBILE
    );
  }

  /*******************************************************************
   FORM
  *******************************************************************/

  private initForm(): void {
    this.form = this.fb.group({
      country: ['', Validators.required],
      mobileNumber: [
        '',
        Validators.compose([
          Validators.required,
          MobileValidator('country')
        ])
      ]
    });
  }

  get f(): any {
    return this.form.controls;
  }

  /*******************************************************************
   Private
  *******************************************************************/
  private manageIfHasCurrentPhoneNumber(): void {

    if (!this.currentMobileNumber) {
      // select iran as a default country
      //  this.selectedCountry = this.allCountries.find(item => item.dialCode === '98');
      return;
    }
    const index = this.currentMobileNumber.indexOf('_');
    const dialCode = this.currentMobileNumber.substring(1, index);
    this.phoneNumber = this.currentMobileNumber.substring((index + 1), this.currentMobileNumber.length);
    this.selectedCountry = this.allCountries.find(item => item.dialCode === dialCode);
    this.onPhoneNumberChange();
    this.isReadOnly = true;
  }


  /*******************************************************************
   Public
  *******************************************************************/

  filter(): void {
    let ch = this.searchValue.toLocaleLowerCase();

    this.filteredCountries = this.allCountries
      .filter(ctr =>
        (ctr.name + ctr.dialCode).toLocaleLowerCase().includes(ch));
  }

  selectCountry(countery: CountryInternational): void {
    this.selectedCountry = countery;
    this.showOptionsCart(false);
    this.onPhoneNumberChange();
  }

  onPhoneNumberChange(): void {
    this.form.controls['country'].patchValue((this.selectedCountry.iso2));
    this.form.controls['mobileNumber'].patchValue((this.phoneNumber + ''));

    if (this.form.valid) {
      this.phoneNumberEmit.emit('+' + this.selectedCountry.dialCode + '_' + this.toEnNumbers(this.phoneNumber));
    } else {
      this.phoneNumberEmit.emit('');
    }
  }

  showOptionsCart(show: boolean): void {
    if (this.currentMobileNumber) { return; }
    this.showOptions = show;
  }

  private toEnNumbers(numbers: string): string {
    let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];

    for (let i = 0; i < 10; i++) {
      numbers = numbers.replace(persianNumbers[i], i.toString());
    }
    return numbers;
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      if (this.showOptions) {
        this.showOptions = false;
      }
    }

  }




}


